import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { getGovSupportList } from '../../api'
import { GenericItemList, LoadMoreButton } from '../../components'
import { ENTRIES_PER_PAGE } from '../../constants'
import { useDocumentTitle } from '../../hooks'
import { NewsItem } from '../../interfaces'
import { useAppContextStore } from '../../store'

export const GovSupportList = () => {
  const { i18n } = useTranslation()
  const explanatoryTexts = useAppContextStore((state) => state.explanatoryTexts)

  useDocumentTitle(explanatoryTexts['gov-support-title'])

  const [data, setData] = useState<NewsItem[]>()
  const [hasMore, setHasMore] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)

  const { isLoading } = useQuery<NewsItem[]>(
    ['gov-support-list', currentPage],
    () => getGovSupportList(i18n.language, currentPage),
    {
      onSuccess: (response) => {
        setHasMore(response.length === ENTRIES_PER_PAGE)

        const nextList = (data || []).concat(response)

        setData(nextList)
      },
    }
  )

  const onLoadMore = () => {
    setCurrentPage(currentPage + 1)
  }

  return (
    <GenericItemList
      label={explanatoryTexts['gov-support-title']}
      slug="/gov-support/"
      isLoading={isLoading}
      data={data}
    >
      <LoadMoreButton hasMore={hasMore} isLoading={isLoading} onLoadMore={onLoadMore} />
    </GenericItemList>
  )
}
